var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPhoto48Filled = function SvgIconPhoto48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V14.6c0-2.92-2.38-5.3-5.3-5.3Zm0 21.97c-.53.9-1.46 1.43-2.5 1.43H17.3c-1.07 0-2.05-.59-2.56-1.53-.5-.95-.45-2.09.14-2.98l1.73-2.6c.54-.81 1.44-1.29 2.41-1.29.97 0 1.87.48 2.41 1.29l1.43 2.14 2.56-4.61a2.91 2.91 0 0 1 5.08 0l2.93 5.27c.5.91.49 1.98-.04 2.88h.01Z",
    fill: "current"
  })));
};
export default SvgIconPhoto48Filled;